// extracted by mini-css-extract-plugin
export default {"nav":"Nav_nav__VTfRK","brand":"Nav_brand__an4L6"};